import React, { useEffect, useRef } from 'react';
import { ShopifyLoader } from './ShopifyLoader.jsx';

const ShopifyProductEmbed = ({
                                 shopDomain = process.env.REACT_APP_SHOPIFY_DOMAIN || '1gu0f6-zh.myshopify.com',
                                 storefrontAccessToken = process.env.REACT_APP_STOREFRONT_ACCESS_TOKEN || '680c9dd2cfbf1bb6cccccca3910b6306',
                                 productId,
                                 componentId
                             }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        const init = async () => {
            await ShopifyLoader();

            const client = window.ShopifyBuy.buildClient({
                domain: shopDomain,
                storefrontAccessToken,
            });

            window.ShopifyBuy.UI.onReady(client).then((ui) => {
                ui.createComponent('product', {
                    id: productId,
                    node: containerRef.current,
                    moneyFormat: '%24%7B%7Bamount%7D%7D',
                    options: {
                        product: {
                            styles: {
                                product: {
                                    "@media (min-width: 601px)": {
                                        "max-width": "100%",
                                        "margin-left": "0",
                                        "margin-bottom": "50px"
                                    },
                                    "text-align": "left",
                                },
                                title: {
                                    "font-size": "26px"
                                },
                                price: {
                                    "font-size": "18px"
                                },
                                compareAt: {
                                    "font-size": "15px"
                                },
                                unitPrice: {
                                    "font-size": "15px"
                                }
                            },
                            buttonDestination: 'cart',
                            layout: 'horizontal',
                            width: '100%',
                            contents: {
                                img: false,
                                imgWithCarousel: true,
                                title: true,
                                price: true,
                                description: true,
                                quantity: false
                            }
                        },
                        cart: {
                            styles: {
                                button: {
                                    "font-size": "16px",
                                    "padding-top": "16px",
                                    "padding-bottom": "16px",
                                }
                            },
                            text: {
                                total: 'Subtotal',
                                button: 'Checkout'
                            }
                        },
                        modalProduct: {
                            contents: {
                                img: false,
                                imgWithCarousel: true,
                                quantity: true,
                                buttonWithQuantity: false,
                                button: true
                            },
                            styles: {
                                product: {
                                    "@media (min-width: 601px)": {
                                        "max-width": "100%",
                                        "margin-left": "0px",
                                        "margin-bottom": "0px"
                                    }
                                }
                            }
                        }
                    }
                });
            });
        };

        init();

        return () => {
            if (containerRef.current) {
                containerRef.current.innerHTML = '';
            }
        };
    }, [productId, shopDomain, storefrontAccessToken]);

    return (
        <div className="shopify-embed-wrapper" style={{ width: '80%', margin: '0 auto', background: '#b0c7d2', border: '2px solid black', marginBottom: '5%', paddingTop: '2.5%', paddingBottom: '2.5%'}}>
            <div ref={containerRef} id={componentId}></div>
        </div>
    );
};

export default ShopifyProductEmbed;
